import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

const SpacesListChildrenCell = ({
  item: node,
  ...cellProps
}: TableSimpleCellProps<TreeNode<SpaceWithParentAccessLevel>>) => {
  const childrenCount = node.children.length;

  return (
    <TableSimpleCell {...cellProps}>
      {childrenCount > 0 ? <TableCellText>{childrenCount}</TableCellText> : <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default SpacesListChildrenCell;
